import { HorizontalGreyBlackField, HorizontalGreyBlackFieldInput } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { Trigger } from "features/Trigger/TemplateTrigger/models";
import SchedulingTriggerModalButton from "../Button/SchedulingTriggerModalButton";
import TriggerButton from "../Button/TriggerButton";

interface TriggerFieldProps {
  form: any;
  label: string;
  labelProps?: object;
  fieldName: string;
  disabled?: boolean;
  nullLabel?: string;
  timingOnly?: boolean;
  excludeTimeOfDay?: boolean;
  allowWeekendsFieldName?: string;
  allowWeekendsReadOnly?: boolean;
}

export default function TriggerField({
  form,
  fieldName,
  label,
  labelProps = {},
  disabled,
  nullLabel = undefined,
  timingOnly = false,
  excludeTimeOfDay = false,
  allowWeekendsFieldName,
  allowWeekendsReadOnly = false,
  ...props
}: TriggerFieldProps) {
  const { formState: { errors } } = form;
  return (
    <HorizontalGreyBlackFieldInput
      label={label}
      labelContainerProps={longAttributeStyles.labelContainerProps}
      labelProps={labelProps}
      name={fieldName}
      errors={errors}
    >
      <SchedulingTriggerModalButton
        form={form}
        label={label}
        fieldName={fieldName}
        disabled={disabled}
        nullLabel={nullLabel}
        timingOnly={timingOnly}
        excludeTimeOfDay={excludeTimeOfDay}
        allowWeekendsFieldName={allowWeekendsFieldName}
        allowWeekendsReadOnly={allowWeekendsReadOnly}
        {...props}
      />
    </HorizontalGreyBlackFieldInput>
  );
}

interface ShowTriggerProps {
  trigger: Trigger;
  label: string;
  labelProps?: object;
}

export function ShowTrigger({ trigger, label, labelProps = {} }: ShowTriggerProps) {
  return (
    <HorizontalGreyBlackField
      label={label}
      labelContainerProps={longAttributeStyles.labelContainerProps}
      labelProps={labelProps}
    >
      <TriggerButton trigger={trigger} descriptor={trigger?.data?.descriptor as string} buttonVariant="unstyled" disabled />
    </HorizontalGreyBlackField>
  );
}
